import { useSidebarPreferences } from './useSidebarPreferences';
import { useSyncSidebarPinState } from './useSyncSidebarPinState';

export function useUserSidebarPreference(feature: string) {
  const { isInitialized } = useSidebarPreferences(feature);
  useSyncSidebarPinState(isInitialized, feature);
}
